import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { credentialsRoutes } from './routes';
import { API_SERVICE_NAMES } from 'src/constants/apiServiceName';
export class Credentials {
  constructor() {
    _defineProperty(this, "routes", credentialsRoutes);
  }
  /**
   * The company's AppFolio chart of accounts. Typed rather than `void`, which it was: it has always
   * answered with the accounts, and every caller has always read them off it.
   */
  async getGLAccounts(options) {
    const resp = await requestService(API_SERVICE_NAMES.APPFOLIO).get(this.routes.glAccounts, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getAppfolioProperties(options) {
    const resp = await requestService(API_SERVICE_NAMES.APPFOLIO).get(this.routes.properties, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async patchAppfolioProperties(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.APPFOLIO).patch(this.routes.properties, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getCredentials(options) {
    const resp = await requestService(API_SERVICE_NAMES.APPFOLIO).get(this.routes.baseUrl, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postCredentials(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.APPFOLIO).post(this.routes.baseUrl, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getCredentialsUsers(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.APPFOLIO).get(this.routes.credentialsUsersById(data.credentialsId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getCredentialsProperties(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.APPFOLIO).get(this.routes.credentialsPropertiesById(data.credentialsId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getGlAccounts(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.APPFOLIO).get(this.routes.credentialsGlAccountsById(data.credentialsId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async patchCredentialsProperties(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.APPFOLIO).patch(this.routes.credentialsPropertiesById(data.credentialsId), {
      properties: data.requestData
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async deleteCredential(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.APPFOLIO).delete(this.routes.credentialsById(data.credentialsId), {
      isHardDelete: data.isHardDelete
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async patchCredentials(data, options) {
    const credentialsId = data.credentialsId,
      requestData = data.requestData;
    const resp = await requestService(API_SERVICE_NAMES.APPFOLIO).patch(this.routes.credentialsById(credentialsId), _objectSpread({}, requestData), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getPropertiesById(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.APPFOLIO).get(this.routes.propertiesById(data.propertyLivableId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getPendingBatches(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.APPFOLIO).get(this.routes.pendingBatches(data.propertyLivableId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getPendingBatchesById(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.APPFOLIO).get(this.routes.pendingBatchesById(data.propertyLivableId, data.batchExternalId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
}